import { render, staticRenderFns } from "./VerFacturacionPantalla.vue?vue&type=template&id=6a017a46&"
import script from "./VerFacturacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./VerFacturacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6a017a46', component.options)
    } else {
      api.reload('6a017a46', component.options)
    }
    module.hot.accept("./VerFacturacionPantalla.vue?vue&type=template&id=6a017a46&", function () {
      api.rerender('6a017a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/VerFacturacion/VerFacturacionPantalla.vue"
export default component.exports